import { styled, media } from 'src/styles/styled-components'

export default styled.p`
  font-size: 1.8rem;
  font-weight: ${ p => p.theme.fontWeight.primary.Light };
  line-height: 1.6;
  text-align: center;

  ${ media.tablet`
    letter-spacing: 0.01em;
  ` }

  ${ media.desktop`
    font-size: 2.8rem;
    letter-spacing: normal;
  ` }
`
